import { useEffect, useState, useRef } from 'react';

import { Field, ErrorMessage, useFormikContext } from 'formik';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';
import styles from './Text.module.scss';

const Text = ({ className, loading, label, prefix, length, nlp }) => {

  const { token } = useAPIContext();
  const [ _loading, _setLoading ] = useState(false);

  prefix = prefix || '';
  const { values: { text }, setFieldValue } = useFormikContext();
  const ref = useRef();

  /*
   * prefix
   */

  useEffect(() => {
    if (text.trim().length === 0) {
      setFieldValue('text', prefix);
    }
  }, [prefix, text, setFieldValue]);

  const onChangeValue = (event) => {

    let value = event.target.value;

    if (!value.startsWith(prefix)) {
      value = prefix + value.slice(prefix.length);
    }

    if (length.max) {
      if (value.length > length.max) {
        value = value.slice(0, length.max);
      }
    }

    setFieldValue('text', value);
  };

  const onChangeCursor = () =>{

    if (ref.current && ref.current.selectionStart <= prefix.length) {
      ref.current.selectionStart = prefix.length;
      ref.current.selectionEnd = prefix.length;
    }
  };

  /* 
   * counter
   */

  length.gross = text.length;
  length.net = length.gross - prefix.length;

  /*
   * nlp
   */

  const validate = (value) => {

    return new Promise((resolve, reject) => {

      if (!value || (value.length === prefix.length)) {
        resolve('The review text is required.');
        return;
      }

      if (length.min) {
        if ((value.length - prefix.length) < length.min) {
          resolve('The review text is too short.')
          return;
        }
      }

      if (length.max) {
        if (value.length > length.max) {
          resolve('The review text is too long.');
          return;
        }
      }

      if (!nlp) {
        resolve();
        return;
      }

      _setLoading(true);

      api(token).v1.nlp.check
        .post({
          text: value,
          ...nlp,
        })
        .then(res => {
          _setLoading(false);

          if (res.status === 200) {
            if (res.body.result) {
              resolve();
              return;
            }
          }

          resolve(`
            Your review doesn't meet our quality standards. Please
            read the instructions above carefully.
          `);
        })
        .catch(err => {
          _setLoading(false);
          toast.show(toast.KIND.WARNING, err);
          reject(err);
        });
    });
  };

  /*
   * content
   */

  return (
    <div className={`${styles.root} ${className || ''}`}>

      <label htmlFor='text'>{label}</label>

      <div className={styles.box}>
        <Field
          innerRef={ref}
          id='text'
          as='textarea'
          name='text'
          disabled={loading || _loading}
          rows={5}

          onChange={(event) => onChangeValue(event)}
          onClick={(event) => onChangeCursor(event)}
          onFocus={(event) => onChangeCursor(event)}

          validate={validate}
        />

        <span className={styles.counter}>
          {
            (length.net < length.min)
            ? `${length.net} of ${length.min}`
            : (
              (length.max && length.max === length.gross)
              ? `Maximum length reached.`
              : `${length.net}`
            )
          }
        </span>
      </div>

      <ErrorMessage
        className={styles.error}
        name='text'
        component='div'
      />
    </div>
  );
};

export default Text;